<app-base-payments
  [getTableDataApiMethodName]="getTableDataApiMethodName"
  [showOperationBtns]="true"
  [pageTitle]="pageTitle"
  pageId="payments"
>
</app-base-payments>
